import { z } from "zod";
export const CommunityAsset = z.object({
    id: z.string().uuid(),
    url: z.string(),
    mime: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
});
export const UploadCommunityAssetRequest = z.object({
    fileName: z.string().trim().min(1).max(160),
    mime: z.enum(["image/jpeg", "image/png", "image/webp"]),
    dataBase64: z.string().min(1).max(7_500_000),
    width: z.number().int().positive().max(8000),
    height: z.number().int().positive().max(8000),
});
export const UploadCommunityAssetResponse = z.object({
    asset: CommunityAsset,
});
//# sourceMappingURL=asset.js.map